var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudBackup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 25,
    viewBox: "0 0 38 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.6375 9.4375C29.5608 4.04688 24.7633 0 19 0C14.4242 0 10.45 2.5625 8.47083 6.3125C3.705 6.8125 0 10.7969 0 15.625C0 20.7969 4.25917 25 9.5 25H30.0833C34.4533 25 38 21.5 38 17.1875C38 13.0625 34.7542 9.71875 30.6375 9.4375ZM22.1667 14.0625V20.3125H15.8333V14.0625H11.0833L19 6.25L26.9167 14.0625H22.1667Z",
    fill: "#004BA5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudBackup);
export default __webpack_public_path__ + "static/media/cloudBackup.640e90878a6debddfc48ad6f6ef07f30.svg";
export { ForwardRef as ReactComponent };